export default __webpack_public_path__ + "static/media/app_store.f00d560a.png";